import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function RequiredIndicatorComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("inverted", ctx_r0.inverted);
} }
export class RequiredIndicatorComponent {
    constructor() {
        this._required = false;
        this._inverted = false;
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = typeof value !== 'undefined' && value !== false;
    }
}
RequiredIndicatorComponent.ɵfac = function RequiredIndicatorComponent_Factory(t) { return new (t || RequiredIndicatorComponent)(); };
RequiredIndicatorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RequiredIndicatorComponent, selectors: [["mhe-required-indicator"]], inputs: { required: "required", inverted: "inverted" }, decls: 1, vars: 1, consts: [["class", "required", 3, "inverted", 4, "ngIf"], [1, "required"]], template: function RequiredIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RequiredIndicatorComponent_span_0_Template, 2, 2, "span", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.required);
    } }, dependencies: [i1.NgIf], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequiredIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'mhe-required-indicator', template: "<span *ngIf=\"required\" class=\"required\" [class.inverted]=\"inverted\"> *</span>\n", styles: ["/*# sourceMappingURL=required-indicator.component.css.map */\n"] }]
    }], null, { required: [{
            type: Input
        }], inverted: [{
            type: Input
        }] }); })();
